export enum PublicComputerType {
  ANSWERED_YES = 'ANSWERED_YES',
  ANSWERED_NO = 'ANSWERED_NO',
  NO_ANSWER = 'NO_ANSWER',
}
